export default {"src":"/_next/static/media/ic_my_info.82a259ab.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};